module.exports = __webpack_public_path__ + "static/img/A25.f3cd3743.jpg";